import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Nfttechstack() {
  return (
    <section className="nft_tech_stack chatbot_stack p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="m-auto text-center"
          >
            <h2>Technology Stack We Used</h2>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-4">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={9}
            className="m-auto text-center"
          >
            <div className="nft_tech_main">
              <div className="nft_tech_item">
                <div className="nft_tech_img">
                  <StaticImage
                    src="../../images/services-usa/nft-new/python_logo.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                </div>
                <div className="nft_tech_head">
                  <h6>Python</h6>
                </div>
              </div>
              <div className="nft_tech_item">
                <div className="nft_tech_img">
                  <StaticImage
                    src="../../images/services-usa/nft-new/angular_logo.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                </div>
                <div className="nft_tech_head">
                  <h6>Angular</h6>
                </div>
              </div>
              <div className="nft_tech_item">
                <div className="nft_tech_img">
                  <StaticImage
                    src="../../images/services-usa/nft-new/tensorflow_logo.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                </div>
                <div className="nft_tech_head">
                  <h6>Tensor Flow</h6>
                </div>
              </div>
              <div className="nft_tech_item">
                <div className="nft_tech_img">
                  <StaticImage
                    src="../../images/services-usa/nft-new/pay.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                </div>
                <div className="nft_tech_head">
                  <h6>PayTorch</h6>
                </div>
              </div>
              <div className="nft_tech_item">
                <div className="nft_tech_img">
                  <StaticImage
                    src="../../images/services-usa/nft-new/svm.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                </div>
                <div className="nft_tech_head">
                  <h6>SVM</h6>
                </div>
              </div>
              <div className="nft_tech_item">
                <div className="nft_tech_img">
                  <StaticImage
                    src="../../images/services-usa/nft-new/google_bert.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                </div>
                <div className="nft_tech_head">
                  <h6>Google Bert</h6>
                </div>
              </div>
              <div className="nft_tech_item">
                <div className="nft_tech_img">
                  <StaticImage
                    src="../../images/services-usa/nft-new/spacy.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                </div>
                <div className="nft_tech_head">
                  <h6>SpaCy</h6>
                </div>
              </div>
              <div className="nft_tech_item">
                <div className="nft_tech_img">
                  <StaticImage
                    src="../../images/services-usa/nft-new/mongo_db.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                </div>
                <div className="nft_tech_head">
                  <h6>MongoDB</h6>
                </div>
              </div>
              <div className="nft_tech_item">
                <div className="nft_tech_img">
                  <StaticImage
                    src="../../images/services-usa/nft-new/nltk.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                </div>
                <div className="nft_tech_head">
                  <h6>NLTK</h6>
                </div>
              </div>
              <div className="nft_tech_item">
                <div className="nft_tech_img">
                  <StaticImage
                    src="../../images/services-usa/nft-new/scipy.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                </div>
                <div className="nft_tech_head">
                  <h6>Scipy</h6>
                </div>
              </div>
              <div className="nft_tech_item">
                <div className="nft_tech_img">
                  <StaticImage
                    src="../../images/services-usa/nft-new/scikit.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                </div>
                <div className="nft_tech_head">
                  <h6>Scikit</h6>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Nfttechstack;
